var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-tag user-tag",attrs:{"title":_vm.user.name}},[_c('ion-icon',{staticClass:"user-tag__icon",attrs:{"name":"contact"}}),_vm._v(" "),_c('p',{staticClass:"user-tag__name"},[_vm._v(_vm._s(_vm.user.name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d0d8c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Tag.vue
// module id = null
// module chunks = 